<template>
  <div class="info-card">
    <div v-if="item.icon" class="info-icon">{{ item.icon }}</div>
    <div class="info-label">{{ item.label }}</div>
    <div class="info-value">{{ item.value }}</div>
  </div>
</template>
  
<script setup lang="ts">
import type { InfoItem } from '@/types/InfoItem';

defineProps<{
  item: InfoItem;
}>();
</script>

<style scoped>
.info-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #444;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.info-icon {
  font-size: 1.5em;
}
.info-label {
  font-size: 1em;
  font-weight: bold;
}
.info-value {
  font-size: 1.2em;
  color: #00ff88;
  font-weight: bold;
}
</style> 